import * as React from 'react';
import * as ReactDOM from 'react-dom';
import LoadingView from './loading-view';


interface Props extends React.HTMLProps<HTMLDivElement>{
    url: string
    onClose?: Function
};

type State = {
    status: string
};

class DocumentOverlay extends React.Component<Props, State> {
  overlayContainer: any
  constructor(props:Props) {
    super(props, {})
    this.state = {
        status:"loading"
    }; 
    this.overlayContainer = document.createElement('div');
    document.body.appendChild(this.overlayContainer);
  }

//  componentDidMount(){
//       var self = this;
//       window.addEventListener("message", function(event){
//           self.handleOverlayClick()
//       })
//   }

 componentDidMount(){
    window.addEventListener("message", this.handleOverlayClick);
  }

  componentWillUnmount() {
      if(this.overlayContainer){
        document.body.removeChild(this.overlayContainer);
      }

      window.removeEventListener("message", this.handleOverlayClick)
  }

  handleOverlayClick = () => {
    document.body.removeChild(this.overlayContainer);
    this.overlayContainer = null
    if(this.props.onClose){
        this.props.onClose()
    }
  }

  documentLoaded = (e:any) => {
      this.setState({status:"ready"})
  }

    render() {
        const {url} = this.props
        const {status}  = this.state
        // let ifvisibility = "visible"
        let loading:any 
        if (status == "loading") {
            // ifvisibility = "hidden"
            loading = <div style={{paddingTop: (window.innerHeight/2)-100}}><LoadingView classes={{}} /></div>
        }
        const initialStyle: React.CSSProperties  = {visibility:status == "loading" ? "hidden" : "visible", position:"absolute", borderWidth:0, top:60, left:60}
        return ReactDOM.createPortal(
          <div style={{zIndex:10002, backgroundColor:"rgba(0,0,0,0.5)", position:"fixed", top:0, left:0, right:0, bottom:0}} onClick={this.handleOverlayClick}>
            {loading}
            <iframe onLoad={this.documentLoaded} style={initialStyle} width={window.innerWidth - 120} height={ window.innerHeight - 120} ref="iframe" src={url}></iframe>
          </div>,
          this.overlayContainer
        );
      }
}

export default DocumentOverlay
